import { useCallback, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { toast } from "sonner";
import { Card, PageHeader } from "@/components/kit";
import { useMe } from "@/components/auth/AccessGate";
import { useApi } from "@/lib/api";

const ROLE_LABEL = { admin: "Administratrice", member: "Cliente" };

export default function Admin({ me: meProp }) {
  const me = useMe() || meProp;
  const api = useApi();
  const [data, setData] = useState(null);
  const load = useCallback(() => api("GET", "/users").then(setData).catch(() => toast.error("Chargement impossible")), [api]);
  useEffect(() => { if (me.role === "admin") load(); }, [me.role, load]);
  if (me.role !== "admin") return <Navigate to="/parcours" replace />;

  const change = async (uid, role) => {
    try {
      await api("PATCH", `/users/${uid}/role`, { role });
      toast.success("Rôle mis à jour");
      load();
    } catch (e) {
      toast.error(e.status === 409 ? "Il faut garder au moins une administratrice." : "Modification refusée");
    }
  };

  return (
    <div data-testid="admin-page">
      <PageHeader eyebrow="Administration" title="Utilisatrices" subtitle="Les comptes créés sur UGC GO et leur statut d'accès." />
      <Card className="p-0 sm:p-0">
        {!data ? <p className="p-6 text-soft">Chargement…</p> : data.users.length === 0 ? <p className="p-6 text-soft">Aucun compte pour l'instant.</p> : (
          <ul>
            {data.users.map((u) => (
              <li key={u.user_id} className="flex flex-col gap-3 border-b border-line px-5 py-4 last:border-0 sm:flex-row sm:items-center sm:justify-between sm:px-7" data-testid={`admin-user-${u.user_id}`}>
                <div className="min-w-0">
                  <p className="truncate font-medium text-ink">{u.email || u.user_id}</p>
                  <p className={`text-xs font-semibold ${u.paid ? "text-bx" : "text-soft"}`}>{u.paid ? "Accès payé" : u.role === "admin" ? "Accès administratrice" : "Non payé"}</p>
                </div>
                <select value={u.role} onChange={(e) => change(u.user_id, e.target.value)} className="rounded-full border border-line bg-white px-4 py-2 text-sm text-ink outline-none focus:border-bx/60" data-testid={`admin-role-select-${u.user_id}`}>
                  {data.roles.map((r) => <option key={r} value={r}>{ROLE_LABEL[r] || r}</option>)}
                </select>
              </li>
            ))}
          </ul>
        )}
      </Card>
    </div>
  );
}
